export default "__VITE_ASSET__OR6_4s_f__"